import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetItemQueryResponse, GetItemQueryParams, GetItem400, GetItem401, GetItem403, GetItem422, GetItem429, GetItem500 } from "../types/GetItem";

export const getItemQueryKey = (params: GetItemQueryParams) =>     [{url:`/api/purchase-tenders/v1/item`},...(params ? [params] : [])] as const;
      export function getItemQueryOptions <TData = GetItemQueryResponse, TError = GetItem400 | GetItem401 | GetItem403 | GetItem422 | GetItem429 | GetItem500>(params: GetItemQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getItemQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/v1/item`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/v1/item
 */

export function useGetItem <TData = GetItemQueryResponse, TError = GetItem400 | GetItem401 | GetItem403 | GetItem422 | GetItem429 | GetItem500>(params: GetItemQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getItemQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getItemQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
